export default class AvaliacaoModeloItem {
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.avaliacaoModeloId = 0;
        this.nome = '';
        this.ordem = 1;
        this.ativo = true;

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId ? model.empresaId : 0;
        this.avaliacaoModeloId = model.avaliacaoModeloId ? model.avaliacaoModeloId : 0;
        this.nome = model.nome;
        this.ordem = model.ordem ? model.ordem : 1;
        this.ativo = model.ativo;
    }
}
